import useAxiosService from './useAxiosService'
import { ILoginQuery } from 'interfaces'
import { IResponse } from 'interfaces/services'

export const useAuthServices = () => {
  const { post, get } = useAxiosService(true)

  const login = async (data: ILoginQuery) => {
    const response: any = await post('/clinic/user/login', data)
    return response
  }

  const logout = async () => {
    const response: any = await get('/clinic/logout')
    return response as IResponse<any>
  }

  const changePassword = async (query: {
    old_password: string
    new_password: string
  }) => {
    const response: any = await post('/clinic/change-password', query)
    return response as IResponse<any>
  }

  return { login, logout, changePassword }
}
